<template>
  <div class="sns-button">
    <a
      v-if="isDispTwitter"
      :data-text="urls.twitter.text"
      :data-url="urls.twitter.url"
      :data-hashtags="urls.twitter.hashtags"
      href="https://twitter.com/share?ref_src=twsrc%5Etfw"
      class="twitter-share-button"
      data-lang="ja"
      data-show-count="false"
      >ツイート</a
    >

    <template v-if="isDispFacebook">
      <iframe
        :src="facebookUrl"
        width="135"
        height="20"
        style="border:none;overflow:hidden"
        scrolling="no"
        frameborder="0"
        allowTransparency="true"
        allow="encrypted-media"
      ></iframe>
    </template>
  </div>
</template>

<script>
import { methods } from '@/utils/methods'
export default {
  head: {
    script: [
      {
        src: 'https://platform.twitter.com/widgets.js',
        async: true,
        charset: 'utf-8',
        body: true
      }
    ]
  },
  props: {
    urls: {
      type: Object,
      required: true
    }
  },
  computed: {
    isDispTwitter() {
      // ieからのアクセスは非表示にする
      const isIe = methods.isIe()
      return this.urls.twitter && Object.keys(this.urls.twitter).length && !isIe
    },
    isDispFacebook() {
      return this.urls.facebook && Object.keys(this.urls.facebook).length
    },
    facebookUrl() {
      if (!this.isDispFacebook) return ''
      return (
        'https://www.facebook.com/plugins/like.php?href=' +
        this.$options.filters.urlencode(this.urls.facebook.url) +
        '&width=135&layout=button&action=like&size=small&share=' +
        this.urls.facebook.share +
        '&height=65&appId=' +
        process.env.FACEBOOK_APP_ID
      )
    }
  }
}
</script>
